import React from "react";
import { Tab } from "semantic-ui-react";
import { LoginForm } from "../../components/AuthInstitutions";
import { Icon } from "../../assets";
import "./AuthInstitution.scss";

export function AuthInstitution() {
  const panes = [
    {
      menuItem: "Entrar",
      render: () => (
        <Tab.Pane>
          <LoginForm />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="auth">
      <Icon.LogoWhite className="logo" />
      <Tab panes={panes} className="auth__form" />
    </div>
  );
}
